<t4-header icon="glyphicon-stats" title="{{ 'Turbo.NotificationSettings.Headline' | translate : 'Notification settings' }}">
  <button mat-button color="primary" matTooltip="{{ 'Turbo.NotificationSettings.Back' | translate : 'Back'}}" type="button" class="btn btn-default" (click)="cancel()"><mat-icon>undo</mat-icon></button>
  @if(setting) {
  <div style="float: right; right: 30px;">
    <button mat-raised-button type="button" style="margin-left: 10px; color: white; background: #ff3333; float: right;" class="btn btn-default" (click)="cancel()" [disabled]="isSaving"><mat-icon>cancel</mat-icon>{{ 'Turbo.NotificationSettings.Cancel' | translate : 'Cancel' }}</button>
    <button mat-raised-button type="button" style="margin-left: 10px; color: white; background: #33aa33; float: right;" class="btn btn-default" (click)="save()" [disabled]="isSaving"><mat-icon>send</mat-icon>{{ 'Turbo.NotificationSettings.cmdSave' | translate : 'Save' }}</button>
  </div>
  }
</t4-header>
<t4-container title="{{ 'Turbo.NotificationSettings.Headline' | translate : 'Notification settings' }}" [isLoading]="isLoading" *ngIf="!setting"></t4-container>
@if(setting) {
<div class="page-layout">
  <div>
    <t4-container title="{{ 'Turbo.NotificationSettings.GeneralSettings' | translate : 'General settings' }}">
      <p>{{ 'Turbo.NotificationSettings.GeneralSettingInfo' | translate : 'Configure the notification and delivery method.' }}</p>
      <div class="form-grid form-grid-3">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.NotificationSettings.Name' | translate : 'Name' }}</mat-label>
          <input matInput maxlength="100" [(ngModel)]="setting.Name" placeholder="{{ 'Turbo.NotificationSettings.ExampleName1' | translate : 'Example: Rental start reminder' }}">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.NotificationSettings.Category' | translate : 'Category' }}</mat-label>
          <mat-select [(ngModel)]="setting.Category">
            <mat-option *ngFor="let category of categories" [value]="category.Id">
              {{ category.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.NotificationSettings.PrimaryDeliveryMethod' | translate : 'Primary delivery method' }}</mat-label>
          <mat-select [(ngModel)]="setting.Method">
            <mat-option *ngFor="let method of methods" [value]="method.Id">
              {{ method.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.NotificationSettings.Priority' | translate : 'Priority' }}</mat-label>
          <mat-select [(ngModel)]="setting.Priority">
            <mat-option *ngFor="let priority of priorities" [value]="priority.Id">
              {{ priority.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.NotificationSettings.DelayBeforeSending' | translate : 'Delay before sending' }}</mat-label>
          <input matInput type="number" min="0" [(ngModel)]="setting.DelayPeriodInMinutes">
          <span matSuffix>{{ 'Turbo.NotificationSettings.Minutes' | translate : 'minutes' }}  </span>
        </mat-form-field>

        <div class="active-setting">
          <mat-slide-toggle [(ngModel)]="setting.IsActive">{{ 'Turbo.NotificationSettings.Active' | translate : 'Active' }}</mat-slide-toggle>
          <div *ngIf="!setting.IsActive">{{ 'Turbo.NotificationSettings.msgNotActive' | translate : 'This notification is disabled. No messages will be created or delivered until it is activated.' }}</div>
        </div>
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'Turbo.NotificationSettings.Title' | translate : 'Title' }}</mat-label>
        <input matInput maxlength="100" [(ngModel)]="setting.Title" placeholder="{{ 'Turbo.NotificationSettings.ExampleTitle' | translate : 'Example: Your booking has been created' }}">
        <mat-hint align="end"> {{ setting.Title?.length || 0 }} / 100 </mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width message-field">
        <mat-label>{{ 'Turbo.NotificationSettings.Message' | translate : 'Message' }}</mat-label>
        <textarea matInput rows="5" maxlength="500" [(ngModel)]="setting.Message" placeholder="{{ 'Turbo.NotificationSettings.EnterMessage' | translate : 'Enter the notification message' }}"></textarea>
        <mat-hint align="end"> {{ setting.Message?.length || 0 }} / 500 </mat-hint>
      </mat-form-field>

      <!--Hiding it till the action setup in the notifications-->
      @if(false){
      <div class="form-grid form-grid-2">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.NotificationSettings.ActionText' | translate : 'Action text' }}</mat-label>
          <input matInput maxlength="100" [(ngModel)]="setting.ActionText" placeholder="{{ 'Turbo.NotificationSettings.ExampleActionText' | translate : 'Example: Open booking' }}">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.NotificationSettings.ActionLink' | translate : 'Action link' }}</mat-label>
          <input matInput type="url" [(ngModel)]="setting.ActionLink" placeholder="https://example.com/booking">
          <mat-error *ngIf="setting.ActionLink && !isValidActionLink()">{{ 'Turbo.NotificationSettings.InvalidActionLink' | translate : 'Enter a complete HTTP or HTTPS URL.' }}</mat-error>
        </mat-form-field>
      </div>
      }
    </t4-container>
    <t4-container title="{{ 'Turbo.NotificationSettings.Schedule' | translate : 'Schedule' }}">
      <p>{{ 'Turbo.NotificationSettings.ScheduleInfo' | translate : 'Schedule the notification period.' }}</p>

      <mat-radio-group [(ngModel)]="setting.IsOneTime" (ngModelChange)="onScheduleTypeChanged()">
        <mat-radio-button [value]="true">{{ 'Turbo.NotificationSettings.OneTime' | translate : 'One time' }}</mat-radio-button>
        <mat-radio-button [value]="false" style="margin-left:20px;">{{ 'Turbo.NotificationSettings.Period' | translate : 'Period' }}</mat-radio-button>
      </mat-radio-group>

      <div *ngIf="setting.IsOneTime" class="form-grid form-grid-2">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.NotificationSettings.ScheduleDate' | translate : 'Schedule date' }}</mat-label>
          <input matInput [matDatepicker]="scheduleDatePicker" [ngModel]="setting.ScheduledAt" (ngModelChange)="onScheduledDateChange($event)">
          <mat-datepicker-toggle matSuffix [for]="scheduleDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #scheduleDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.NotificationSettings.ScheduleTime' | translate : 'Schedule time' }}</mat-label>
          <input matInput type="time" [ngModel]="scheduledTime" (ngModelChange)="onScheduledTimeChange($event)">
        </mat-form-field>
      </div>

      <div *ngIf="!setting.IsOneTime" class="form-grid form-grid-2">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.NotificationSettings.StartDate' | translate : 'Start date' }}</mat-label>
          <input matInput [matDatepicker]="startDatePicker" [(ngModel)]="setting.StartDate">
          <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.NotificationSettings.EndDate' | translate : 'End date' }}</mat-label>
          <input matInput [matDatepicker]="endDatePicker" [(ngModel)]="setting.EndDate">
          <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </t4-container>

    <t4-container title="{{ 'Turbo.NotificationSettings.AudienceConditions' | translate : 'Audience conditions' }}">
      <p>{{ 'Turbo.NotificationSettings.AudienceConditionsInfo' | translate : 'Configure which customers should receive this notification.' }}</p>
      <t4-condition-editor *ngIf="setting && fields.length > 0 && operators.length > 0" [conditions]="setting.Conditions" (conditionsChange)="onConditionsChanged($event)" [fields]="fields" [operators]="operators" [defaultField]="fields[0]?.Id" [defaultOperator]="operators[0]?.Id"></t4-condition-editor>
      <div class="audience-actions">
        <button mat-raised-button color="primary" type="button" (click)="checkAffectedUsers()" [disabled]="!canCheckAffectedUsers() || isLoadingAudienceCount"><mat-icon>groups</mat-icon>{{ 'Turbo.NotificationSettings.CheckAffectedUsers' | translate : 'Check affected users' }}</button>
      </div>
      <div class="audience-preview" *ngIf="isLoadingAudienceCount || affectedUserCount !== null">
        <div class="audience-preview-loading" *ngIf="isLoadingAudienceCount">
          <mat-spinner diameter="22"></mat-spinner>
          <span>{{ 'Turbo.NotificationSettings.CalculatingAudience' | translate : 'Calculating affected users...' }}</span>
        </div>
        <div *ngIf="!isLoadingAudienceCount">
          <mat-icon>groups</mat-icon><strong>   {{ affectedUserCount }} {{ affectedUserCount === 1 ? ('Turbo.NotificationSettings.UserAffected' | translate : 'user currently affected') : ('Turbo.NotificationSettings.UsersAffected' | translate : 'users currently affected') }}</strong><span *ngIf="isAudienceCountOutdated"> {{ 'Turbo.NotificationSettings.AudienceCountOutdated' | translate : '- conditions changed, check again' }}</span>
        </div>
      </div>
    </t4-container>

    <t4-container title="{{ 'Turbo.NotificationSettings.Behaviour' | translate : 'Behaviour' }}" *ngIf="!setting.IsOneTime">
      <p>{{ 'Turbo.NotificationSettings.SendBehaviourInfo' | translate : 'Configure whether the same target may receive this notification more than once.' }}</p>
      <div class="form-grid form-grid-2">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.NotificationSettings.MaximumSendCount' | translate : 'Maximum send count' }}</mat-label>
          <input matInput type="number" min="1" max="10" [(ngModel)]="setting.MaximumSendCount" (ngModelChange)="onMaximumSendCountChanged()">
          <mat-hint>{{ 'Turbo.NotificationSettings.MaximumSendCountHint' | translate : 'Use 1 to send the notification only once.' }}</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="isRepeatEnabled()">
          <mat-label>{{ 'Turbo.NotificationSettings.RepeatInterval' | translate : 'Repeat interval' }}</mat-label>
          <input matInput type="number" min="1" [(ngModel)]="setting.RepeatIntervalInMinutes">
          <span matSuffix>{{ 'Turbo.NotificationSettings.Minutes' | translate : 'minutes' }}</span>
          <mat-hint>{{ 'Turbo.NotificationSettings.RepeatIntervalHint' | translate : 'A repeat is created only after the previous notification was sent successfully.' }}</mat-hint>
        </mat-form-field>
      </div>
      <div class="repeat-warning" *ngIf="isRepeatEnabled()">
        <mat-icon>warning_amber</mat-icon>
        <span>{{ 'Turbo.NotificationSettings.RepeatWarning' | translate : 'This setting can notify the same target multiple times. Use this only for planned reminders.' }}</span>
      </div>
    </t4-container>

    <t4-container title="{{ 'Turbo.NotificationSettings.DeliveryAndRetry' | translate : 'Delivery and retry' }}">
      <p>{{ 'Turbo.NotificationSettings.DeliveryAndRetryInfo' | translate : 'Configure fallback behaviour when the primary delivery fails.' }}</p>
      <div class="delivery-grid">
        <div class="toggle-field">
          <label>{{ 'Turbo.NotificationSettings.UseFallback' | translate : 'Use fallback' }}</label>
          <div class="toggle-content">
            <mat-slide-toggle [(ngModel)]="setting.UseFallback"></mat-slide-toggle>
            <span>{{ setting.UseFallback ? ('Turbo.NotificationSettings.Enabled' | translate : 'Enabled') : ('Turbo.NotificationSettings.Disabled' | translate : 'Disabled') }}</span>
          </div>
        </div>
      </div>

      <div *ngIf="setting.UseFallback" class="fallback-section">
        <div class="form-grid form-grid-2">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Turbo.NotificationSettings.FallbackMethod' | translate : 'Fallback method' }}</mat-label>
            <mat-select [(ngModel)]="setting.FallbackMethod">
              <mat-option *ngFor="let method of methods" [value]="method.Id" [disabled]="method.Id === setting.Method">
                {{ method.Name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="checkbox-field">
            <mat-checkbox [(ngModel)]="setting.SendFallbackImmediatelyOnFailure">
              {{ 'Turbo.NotificationSettings.SendFallbackImmediately' | translate : 'Send fallback immediately after the first failure' }}
            </mat-checkbox>
          </div>
        </div>
      </div>
    </t4-container>
  </div>

  <t4-container title="{{ 'Turbo.NotificationSettings.Preview' | translate : 'Preview' }}">
    <aside class="preview-column">
      <mat-card class="preview-card">
        <mat-card-content>
          <div class="preview-message">
            <div class="preview-message-icon"><mat-icon>notifications</mat-icon></div>
            <div>
              <label>{{ 'Turbo.NotificationSettings.Title' | translate : 'Title' }}</label>
              <strong>{{ setting.Title || ('Turbo.NotificationSettings.NotificationTitleDefault' | translate : 'Notification title') }}</strong>
              <label>{{ 'Turbo.NotificationSettings.Message' | translate : 'Message' }}</label>
              <p>{{ setting.Message || ('Turbo.NotificationSettings.NotificationMessageDefault' | translate : 'The notification message will appear here.') }}</p>
              <button *ngIf="setting.ActionLink" mat-stroked-button color="primary" type="button" [disabled]="!isValidActionLink()" (click)="openPreviewLink()">
                <mat-icon>open_in_new</mat-icon>
                {{ setting.ActionText || ('Turbo.NotificationSettings.OpenLink' | translate : 'Open link') }}
              </button>
            </div>
          </div>
          <mat-divider></mat-divider>
          <div class="preview-summary">
            <div class="summary-row">
              <span>
                <mat-icon>category</mat-icon>
                {{ 'Turbo.NotificationSettings.Category' | translate : 'Category' }}
              </span>
              <strong>{{ getCategoryName(setting.Category) }}</strong>
            </div>

            <div class="summary-row">
              <span>
                <mat-icon>send</mat-icon>
                {{ 'Turbo.NotificationSettings.Delivery' | translate : 'Delivery' }}
              </span>
              <strong>{{ getMethodName(setting.Method) }}</strong>
            </div>

            <div class="summary-row">
              <span>
                <mat-icon>priority_high</mat-icon>
                {{ 'Turbo.NotificationSettings.Priority' | translate : 'Priority' }}
              </span>
              <strong>{{ getPriorityName(setting.Priority) }}</strong>
            </div>

            <div class="summary-row">
              <span>
                <mat-icon>timer</mat-icon>
                {{ 'Turbo.NotificationSettings.Delay' | translate : 'Delay' }}
              </span>
              <strong>
                {{ setting.DelayPeriodInMinutes || 0 }} {{ 'Turbo.NotificationSettings.Minutes' | translate : 'minutes' }}
              </strong>
            </div>

            <div class="summary-row">
              <span>
                <mat-icon>sms</mat-icon>
                {{ 'Turbo.NotificationSettings.Fallback' | translate : 'Fallback' }}
              </span>
              <strong>
                {{ setting.UseFallback ? getMethodName(setting.FallbackMethod) : ('Turbo.NotificationSettings.Disabled' | translate : 'Disabled') }}
              </strong>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </aside>
  </t4-container>
</div>
}
